const API = "./api";

export default {
	method(endpoint, method = "GET", body = null, keepalive = false) {
		let options = {
			method: method,
			headers: {
				Accept: "application/json"
			}
		};
		if (body != null) {
			options.headers["Content-Type"] = "application/json";
			if (typeof body === "string") options.body = body;
			else options.body = JSON.stringify(body);
		}
		if (keepalive) options.keepalive = true;	// the request can outlive page (isn't canceled on unload)
		return fetch(API + endpoint, options);
	},

	getJson(endpoint) {
		return this.method(endpoint);
	},

	deleteJson(endpoint) {
		return this.method(endpoint, "DELETE");
	},

	postJson(endpoint, obj, keepalive = false) {
		return this.method(endpoint, "POST", obj, keepalive);
	},

	putJson(endpoint, obj, keepalive = false) {
		return this.method(endpoint, "PUT", obj, keepalive);
	},

	patchJson(endpoint, obj, keepalive = false) {
		return this.method(endpoint, "PATCH", obj, keepalive);
	}
};
